// extracted by mini-css-extract-plugin
export var divider = "post-module--divider--JgQ1+";
export var grid = "post-module--grid--cPsJs";
export var right = "post-module--right--mqc2I";